import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CSSVarNames, ThemeService, ToastPosition } from '@capturum/ui/api';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  public position: ToastPosition = ToastPosition.TOP_RIGHT;

    constructor(
        private themeService: ThemeService,
        private router: Router,
        private messageService: MessageService,
    ) {
        this.setTheme();
    }

  public setTheme(): void {
    this.themeService.setProps({
        [CSSVarNames.InputHeight]: '36px',
    });
  }

  public navigateFromToast(route?: string): void {
    if (!route) {
      return;
    }

    this.router.navigate([route]);
    this.messageService.clear('link-live-toast');
  }
}
